var Model = require("../types/Model.js");

module.exports = Model({
	name: "remotebluetoothscanner",
	init: init,
	uninit: uninit,
	listeners: listeners
});

function init() {
	this.push(false);
	this._manageGroupTracker = this.dispatcher.createTracker();
}

function uninit(){
	this._manageGroupTracker.off();
	this._manageGroupTracker = null;
}

function listeners() {
	return {
		"mqtt:$/bluetooth/scan/start": begin_scanning,
		"mqtt:$/bluetooth/scan/stop": stop_scanning,
		"bluetooth:scanned": notify_scanned,
		"ownmanagegroup:updated": handle_own_managegroup_updated
	};
}

function begin_scanning() {
	if (this.data) return;
	this.emit("bluetooth:trigger:initialize");
	this.push(true);
	this.emit("bluetoothscanner:trigger:start");
}

function stop_scanning() {
	if (!this.data) return;
	this.push(false);
	this.emit("bluetoothscanner:trigger:stop");
}

function notify_scanned(device) {
	if (!this.data) return;

	// Don't send devices without a human readable name
	if (!device.name) return;
	this.emit("$mqtt:$/bluetooth/scan/scanned", device);
}

function handle_own_managegroup_updated(group){
	const tracker = this._manageGroupTracker;
	tracker.off();
	if(Array.isArray(group)) {
		group.forEach(g=>{
			tracker.on(`mqtt:managegroup/${g}/patient/u/${this.config.id}/bluetooth/scan/start`, begin_scanning.bind(this));
			tracker.on(`mqtt:managegroup/${g}/patient/u/${this.config.id}/bluetooth/scan/stop`, stop_scanning.bind(this));
		});
	} else {
		tracker.on(`mqtt:managegroup/${group}/patient/u/${this.config.id}/bluetooth/scan/start`, begin_scanning.bind(this));
		tracker.on(`mqtt:managegroup/${group}/patient/u/${this.config.id}/bluetooth/scan/stop`, stop_scanning.bind(this));
	}
}
